module.exports = __webpack_public_path__ + "1567f49f3a48028359057df85ce51049.png";